import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'
import endpoints from '../../../API/endpoints'

export const useGetTppIdQuery = (strategyId: string | undefined) => {
    const { getTokenSilently, isAuthenticated, isLoading: authLoading } = useAuth0()

    const canFetch = !!strategyId && !!getTokenSilently && !!isAuthenticated && !authLoading

    return useQuery<string | null>(
        ['tppId', strategyId],
        async () => {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI(
                `${endpoints.getTPPIdByRoadmap.url}/${strategyId}`,
                endpoints.getTPPIdByRoadmap.method,
                token
            )
            return response.data || null
        },
        {
            enabled: canFetch,
        }
    )
}
